import { Box, Card, CardContent, CardHeader, CircularProgress, FormControl, FormControlLabel, FormLabel, IconButton, Radio, RadioGroup, Stack, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { SelectRefreshRate } from "../../components/SelectRefreshRate";
import { SelectVillage } from "../../components/SelectVillage";
import { Dashboard } from "../../enums/Dashboard";
import { HubToDoor } from "./HubToDoor";
import { HubToSpoke } from "./HubToSpoke";
import { SpokeStatusDto } from "./SpokeStatusDto";
import { useSpoke } from "./useSpoke";
import { Asset } from "../../data/Asset";
import RefreshIcon from '@mui/icons-material/Refresh';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import { CheckHealth } from "../Maintenance/components/CheckHealth";


const ASSETS = [ Asset.Niw, Asset.Waio ];


export const SpokeDashboard: React.FC = () => {

    const [ asset, setAsset ] = useState< Asset >( Asset.Waio );
    const [ isDataLoaded, setIsDataLoaded ] = useState< boolean >( false );
    const [ isLoading, setIsLoading ] = useState<boolean>( false );
    const [ selectedVillage, setSelectedVillage ] = useState< string >( '' );
    const [ refreshCount, setRefreshCount ] = useState< number >( 0 );
    const [ refreshRate, setRefreshRate ] = useState< number >( 300_000 );
    const [ spokeStatus, setSpokeStatus ] = useState< SpokeStatusDto | null >( null );

    const [ getSpokeStatus ] = useSpoke( );

    useEffect(() => {

        if ( !selectedVillage ) {
            
            return;

        }

        const interval = setInterval( ( ) => {
          
            setRefreshCount( refreshCount => refreshCount + 1 );

        }, refreshRate );

        return () => clearInterval( interval );

    }, [ refreshRate, selectedVillage ]);


    // useEffect(() => {

    //     if ( !selectedVillage ) {
            
    //         return;

    //     }

    //     if( selectedEvents.length === 0 ) {
            
    //         return;

    //     }

    //     setCookie( SelectedVillageCookie.IotGatewayDashboard, selectedVillage );
    //     setCookie( Cookie.IotGatewayEvents, JSON.stringify( selectedEvents ) );

    // }, [ selectedVillage, selectedEvents ]);

    useEffect( ( ) => {

        if( !selectedVillage ) {

            return;

        }
        
        const fetchSpokeStatus = async ( ) => {

            if( refreshCount === 0 ) {
                
                setIsLoading( true );
            }

            const spokeStatus = await getSpokeStatus( selectedVillage );
            setIsDataLoaded( true );
            
            if( refreshCount === 0 ) {
            
                setIsLoading( false );

            }

            setSpokeStatus( spokeStatus );
            

        };
        
        fetchSpokeStatus( );

    }, [ selectedVillage, refreshCount ]);


    const handleAssetChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {

        const asset = (event.target as HTMLInputElement).value as Asset
        setAsset( asset );
        setSelectedVillage( '' );
        setSpokeStatus( null );
        setIsDataLoaded( false );

    };


    const handleResetClick = ( ) => {

        setAsset( Asset.Waio );
        setSelectedVillage( '' );
        setSpokeStatus( null );
        setIsDataLoaded( false );

    };
    

    return (

        <>

            <CheckHealth />
        
            <Stack direction="row" display="flex" justifyContent="center" gap={ 0.5 } sx={{ marginTop: '50px' }}>


                <Card sx={{ maxWidth: 'fit-content', boxShadow: 5 }}>

                    <CardHeader 
                        sx={{ fontWeight: '600', fontSize: '20px', paddingTop: '5px', paddingBottom: '0' }}
                        title="Select a village"
                        avatar={
                            <TravelExploreIcon />
                        }
                        action={
                            <Tooltip title="Reset">
                                <IconButton onClick={ handleResetClick }>
                                    <RefreshIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    />

                    <CardContent>

                        <Stack direction="row" gap={ 1 } display="flex" alignItems="center" >
                            
                            <FormControl 
                                disabled={ isLoading || ASSETS.length === 1 }
                            >
                                <FormLabel>Asset</FormLabel>
                                <RadioGroup 
                                    value={asset}
                                    onChange={ handleAssetChange }
                                >
                                    
                                    {
                                        ASSETS.map( a => 
                                            <FormControlLabel key={ a } value={ a } control={ <Radio /> } label={ a } sx={{ marginBottom: '-5px', marginTop: '-10px' }} />
                                        )
                                    }

                                </RadioGroup>
                            </FormControl>

                            <SelectVillage asset={ asset } dashboard={ Dashboard.Spoke } onSelectVillage={ setSelectedVillage } />
                            <SelectRefreshRate selectRefreshRate={ setRefreshRate } />
                        </Stack>
                    </CardContent>

                </Card>

            </Stack>

            <br />


            {
                isLoading
                    ?
                <Box 
                    display="flex" 
                    alignItems="center"
                    justifyContent="center"
                >
                    <CircularProgress size="80px" sx={{color: '#e65400'}}/>
                </Box>
                    :
                <>

                    {
                        spokeStatus
                            ?
                        <>
                        
                            <HubToSpoke spokeStatus={ spokeStatus } />
                            <br />
                            <br />
                            <HubToDoor spokeSummaryCount={ spokeStatus.summaryCounts } />

                        </>
                            :
                        
                        <>
                            {
                                isDataLoaded
                                    &&
                                <span>
                                    Village Spoke is not set up ...
                                </span>
                            }
                        </>

                    }

                </>

            }
        
        </>

    );

};